module.exports = __webpack_public_path__ + "img/satisfied_green.5fb4c6a1.png";